import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import {
  TransactionPdfData,
  TransactionsGeneratePdf,
} from "../pdf/transactions-pdf";
import { pdf } from "@react-pdf/renderer";
import {
  IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction,
  Maybe,
} from "../../../../generated";
import { PDFViewer } from "../../../shared/pdf-viewer";

interface SendMoneyFormProps {
  amount: number;
  reason: string;
  isAdmin: boolean;
  showModal: () => void;
  transactions: any;
  id: string;
}

const SendMoneyForm: React.FC<SendMoneyFormProps> = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<
    | IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction
    | undefined
  >(undefined);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

  useEffect(() => {
    const generatePdf = async () => {
      if (selectedTransaction) {
        const transactionData: TransactionPdfData = {
          tableData: selectedTransaction,
          amountLabel: "Refund Amount:",
        };
        try {
          // Generate the PDF asynchronously and set the blob state
          const blob = await pdf(
            <TransactionsGeneratePdf data={transactionData} />
          ).toBlob();
          console.log("Generated PDF Blob:", blob);
          setPdfBlob(blob);
        } catch (error) {
          console.error("Error generating PDF:", error);
        }
      }
    };

    generatePdf();
  }, [selectedTransaction]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedTransaction(undefined);
    setPdfBlob(null);
  };

  const showModal = (
    transaction: IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction
  ) => {
    const filterData = props?.transactions?.adhocTransactions.find(
      (item: {
        amount: Maybe<number> | undefined;
        reason: Maybe<string> | undefined;
      }) =>
        Math.abs(item.amount || 0) === transaction.amount &&
        item.reason === transaction.reason
    );
    setSelectedTransaction(filterData);
    setIsModalVisible(true);
  };
  const commonStyles = {
    padding: "10px",
    color: "black",
    borderRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    background: "rgb(255, 251, 251)",
    width: "100%",
    margin: "10px 5px",
  };

  const viewButton = {
    backgroundColor: "white",
    color: "black",
    border: "1px solid #ccc",
    boxShadow: "none",
    borderRadius: "2px",
    margin: "10px 5px",

  };

  const refundMessage = {
    color: "black",
    backgroundColor: "rgb(219, 255, 197)",
    borderRadius: "10px",
    padding: " 5px",
    margin: '0px 24px 0px 0px',
    textAlign: "center",

  };
  const refundInformationContainer = {
    display: "flex",
    justifyContent: "space-between",
    maxHeight: "100px",
    height: "70px",
    alignItems: "center",
  };

  const message = props.isAdmin
    ? `US$${props.amount} Sent Successfully for ${props.reason}`
    : `US$${props.amount} Received Successfully for ${props.reason}`;

  return (
    <div style={refundInformationContainer}>
      <div
        style={{
          ...commonStyles,
          paddingTop: "0px",
          paddingLeft: "0px",
          paddingBottom: "0px",
          borderRadius: "10px",
        }}
      >
        <div style={refundMessage as React.CSSProperties}>{message}</div>

        <Button
          style={viewButton}
          type="primary"
          onClick={() => showModal(props)}
        >
          View Receipt
        </Button>
      </div>
      {isModalVisible && (
        <Modal
          title={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`}
          width="fit-content"
          open={isModalVisible}
          closable
          footer={[
            <Button key="close" onClick={handleCancel}>
              Close
            </Button>,
          ]}
          onCancel={handleCancel}
          destroyOnClose
        >
          {pdfBlob ? (
            <PDFViewer
              filename={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`}
              docId=""
              blobPromise={Promise.resolve(pdfBlob)}
            ></PDFViewer>
          ) : (
            <p>Loading PDF...</p>
          )}
        </Modal>
      )}
    </div>
  );
};

export default SendMoneyForm;
